const urlParams = new URLSearchParams(window.location.search);
const token = urlParams.get("claim_token");
let selectedGifts = [];
const mainContainer = document.querySelector(".main-container");
const pageContainer = document.querySelector(".main-collection-container");
const spinner = document.querySelector(".spinner");

const accessDeniedHTML = `<div class="denied-container">
  <h1>Access Denied</h1>
  <p>You are not authorized to view this page. Redirecting to homepage...</p>
</div>`;

const linkExpiredHTML = `<div class="denied-container">
  <h1>Oops!! You Missed it.</h1>
  <p>Link is expired, redirecting to the homepage...</p>
</div>`;
  console.log({token})
if (!token) {
  pageContainer.innerHTML = accessDeniedHTML;
  // Redirect after 3 seconds
  setTimeout(() => {
    window.location.href = "https://shadowbreeze.com/";
  }, 3000);
}
let isExpired  = false;
console.log("making veiryf api call ")
fetch(`https://api.shadowbreeze.com/user/verify/${token}`, {
  headers: {
    'ngrok-skip-browser-warning': 'true'
  }
})
  .then((res) => {
    console.log("call done ")
    return res.json();
  })
  .then((data) => {
    if (!data.success) {
      if(data.message === "Token expired") {
        isExpired = true;

        throw new Error("Expired");
      }
      throw new Error(`Unauthenticated`);
    }
    const tokenData = data.data;
    selectedGifts = tokenData.selectedGifts;
    console.log({selectedGifts})
    const senderName = tokenData?.senderName||"";
    const recipientName = tokenData?.recipientName||"";

    document.getElementById("recipient-name").textContent = recipientName;
    document.getElementById("sender-name").textContent = senderName;

    // You can handle successful response here
    spinner.classList.add("hide");
    mainContainer.classList.remove("hide");
    document.querySelector(".collection-recipient-info-section").classList.remove("hide");

    const allProductBlocks = document.querySelectorAll(
      ".product-block-container"
    );
    console.log({allProductBlocks})
    allProductBlocks.forEach((block) => {
      const productId = block.getAttribute("data-product-id");
      // Hide block if product ID is not in selectedGifts
      console.log(productId.toString())
      if (!selectedGifts.includes(productId.toString())) {
        block.style.display = "none";
      } else {
        console.log(productId.toString())
      }
    });
  })
  .catch((err) => {
    console.error("Error comes here:", err);  

    // Show access denied or expired token UI
    if(isExpired) {
      pageContainer.innerHTML = linkExpiredHTML;
    } else {
      pageContainer.innerHTML = accessDeniedHTML;

    }
    setTimeout(() => {
      window.location.href = "https://shadowbreeze.com/";
    }, 3000);
  });

document.addEventListener("DOMContentLoaded", () => {});